import React, {Component} from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import './dateSelection.css'

class DateSelection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: moment().startOf('month'),
      endDate: moment(),
      activeMonth: true,
      activeMonthEnd: true,
      compareStartDate: moment().startOf('month'),
      compareEndDate: moment()
    }
  }
  handleStartDateChange(startDate) {
    this.props.startDateChange(startDate.format('YYYY-MM-DD'))
    this.handleChange({ startDate })
  }
  handleEndDateChange(endDate) {
    this.props.endDateChange(endDate.format('YYYY-MM-DD'))
    this.handleChange({ endDate })
  }
  handleChange({ startDate, endDate }) {
    startDate = startDate || this.state.startDate
    endDate = endDate || this.state.endDate

    if (startDate.isAfter(endDate)) {
      endDate = startDate
      this.setState({
        compareEndDate: startDate
      })
    }

    this.setState({
      startDate,
      endDate
    })
  }
  handleClickDateWrapper () {
    let eles = document.querySelectorAll('.react-datepicker__day-name');
    // change month name
    for (const v of eles) {
      v.innerText = v.innerText.substring(0, 1)
    }
  }
  handleOnMonthChange (date) {
    this.setState({
      compareStartDate: date
    })
  }
  handleOnEndMonthChange (date) {
    this.setState({
      compareEndDate: date
    })
  }

  /**
   * this callback of apply button
   */
  handleApplyBeClick() {
    this.props.handleApplyBeClick()
  }
  render () {
    return (
      <div className="date-selection">
        <h2>DATE SELECTION</h2>
        <p>
          Select the time period you are interested in viewing.
        </p>
        <div className="content clearfix">
          <span>From:</span>
          <div className="start-date clearfix">
            <div className="icon-wrapper">
              <i className="far fa-calendar-alt" />
            </div>
            <div className="date-wrapper" onClick={() => this.handleClickDateWrapper()}>
              <DatePicker
                dateFormat="MM-DD-YYYY"
                calendarClassName="calendar-left"
                className="date-con"
                selected={this.state.startDate}
                startDate={this.state.startDate}
                filterDate={(date) => date.format('M') === this.state.compareStartDate.format('M')}
                onMonthChange={(date) => this.handleOnMonthChange(date)}
                onChange={(date) => this.handleStartDateChange(date)}
              />
            </div>
          </div>
          <strong className="line"></strong>
          <span>To:</span>
          <div className="end-date">
            <div className="icon-wrapper">
              <i className="far fa-calendar-alt" />
            </div>
            <div className="date-wrapper" onClick={() => this.handleClickDateWrapper()}>
              <DatePicker
                dateFormat="MM-DD-YYYY"
                calendarClassName="calendar-left"
                className="date-con"
                endDate={this.state.endDate}
                selected={this.state.endDate}
                filterDate={(date) => date.format('M') === this.state.compareEndDate.format('M')}
                onMonthChange={(date) => this.handleOnEndMonthChange(date)}
                onChange={(date) => this.handleEndDateChange(date)}
              />
            </div>
          </div>
          <button className="apply" onClick={() => this.handleApplyBeClick()}>APPLY</button>
        </div>
      </div>
    )
  }
}

export default DateSelection;


// WEBPACK FOOTER //
// ./src/components/InsightsInfo/DateSelection/Date.jsx